import { render, staticRenderFns } from "./userCityNumber.vue?vue&type=template&id=355bb962&scoped=true"
import script from "./userCityNumber.vue?vue&type=script&lang=js"
export * from "./userCityNumber.vue?vue&type=script&lang=js"
import style0 from "./userCityNumber.vue?vue&type=style&index=0&id=355bb962&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355bb962",
  null
  
)

export default component.exports